module.exports = __webpack_public_path__ + "img/82_movie_director.936a3b10.jpg";